import BaseModel from './BaseModel'

export default class PromotionModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            name: ['name', undefined, value => value],
            imageUrl: ['imageUrl', undefined, value => value],
            detail: ['detail', undefined, value => value],
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
        imageUrl: 'Ссылка на изображение',
        detail: 'Детальный текст',
    }
}
